import { CenterDistanceForDTO } from "api/centers.api";
import { PromotionCodeDTO } from "api/promo.api";
import {
  EncounterAppointmentDto,
  EncounterDto,
  OfflineBookings,
  OnlineBookingExtended,
  PackageDto
} from "src/api/entities/encounters";
import { CacAnswers } from "api/medicalData.api";
import { LocationQueryValue } from "vue-router";
import { AddonTypes } from "src/types/addons";

export interface BookingState {
  encounterId?: string;
  sex?: string;
  dob?: string;
  offlineBookings: Record<number, OfflineBookings>;
  onlineBookings: Record<number, OnlineBookingExtended>;
  packages?: PackageDto[];
  package?: PackageDto;
  center?: CenterDistanceForDTO;
  availableCenters?: CenterDistanceForDTO[];
  memberDiscount?: MemberDiscount;
  validEntry?: boolean;
  validAssociateEntry?: boolean;
  validEntryAppointmentActions?: boolean;
  validEntryPaymentAuthorization?: boolean;
  bookingType?: string;
  availableDiscounts: PromotionCodeDTO[];
  utmParams?: UtmParmeters;
  promoCode?: PromotionCodeDTO;
  cacAnswers: CacAnswers;
  finalPrice?: string;
  additionalBookingInformation?: string;
  currentAppointment?: EncounterAppointmentDto;
  selectedAddons: AddonTypes;
  eventCenterId?: string | null;
  // Blocks sole-event-center auto-select of a center that was just reported unavailable.
  lastUnavailableCenterId?: string;
  isDeferred?: boolean;
  deferredEncounter?: EncounterDto;
  isChangeLocation?: boolean;
}

export interface MemberDiscount {
  type: MemberDiscountType;
  promoCode?: PromotionCodeDTO;
}

export enum MemberDiscountType {
  REFERRAL = "REFERRAL",
  INVITED = "INVITED",
  SPONSORED = "SPONSORED"
}

export interface UtmParmeters {
  utmSource: string | LocationQueryValue[] | undefined;
  utmMedium: string | LocationQueryValue[] | undefined;
  utmCampaign: string | LocationQueryValue[] | undefined;
  utmContent: string | LocationQueryValue[] | undefined;
  utmGclid: string | LocationQueryValue[] | undefined;
  utmTerm: string | LocationQueryValue[] | undefined;
}
